export default {
  CommunityPage: "690b696a-d887-47c6-b19b-db81cf88941a",
  MpcPage: "02b3d869-0a20-471b-b6ec-f6e35ce69899",
  CondoPlan: "5fb00a9b-815c-4de1-9837-434b23db8168",
  CarrersPage: "c4b53666-aa96-4b50-aa7c-e334af7299f7",
  PromoPage: "9496e290-dada-4307-bbb3-26f4c48170e7",
  PlanPage: "33263be4-b5f9-4980-8ada-153196389af3",
  QMIPage: "7492a8a2-ec74-4934-8370-f51274db785c",
  CondoPage: "51F1576C-BBD6-4E1E-8AEA-A40C09663BF8"
};
